import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/deployment/bundle-sell.md?raw';

const DeploymentBundleSell: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default DeploymentBundleSell;
